import { CalendarCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const STEPS = [
    {
        n: "01",
        title: "Start with a check-in",
        text: "A short health questionnaire and three simple checks used in fall-prevention programs (a 30-second chair stand, a standing balance check and a timed walk).",
    },
    {
        n: "02",
        title: "Practice in a small group",
        text: "Patient, step-by-step instruction in small groups with a low participant-to-instructor ratio, and nobody pushed past what's right for them.",
    },
    {
        n: "03",
        title: "See your progress",
        text: "Repeat the same checks at the end and compare.",
    },
    {
        n: "04",
        title: "Keep it up",
        text: "Ongoing practice to keep the skills.",
    },
];

export default function Steps() {
    return (
        <section id="how-it-works" className="scroll-mt-24 pb-10 sm:pb-14 lg:pb-28">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <SectionHead eyebrow="The program" title="How it works" />
                </Reveal>
                <ol className="mt-8 grid sm:mt-12 gap-8 sm:grid-cols-2 lg:grid-cols-4">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.08} className="h-full">
                            <li className="h-full border-t-2 border-clay pt-6" data-testid={`step-${i + 1}`}>
                                <span className="font-display text-5xl font-black text-teal-600 sm:text-6xl" aria-hidden="true">
                                    {s.n}
                                </span>
                                <h3 className="mt-3 font-display text-xl font-extrabold text-ink">{s.title}</h3>
                                <p className="mt-2 text-lg leading-relaxed text-ink-soft">{s.text}</p>
                            </li>
                        </Reveal>
                    ))}
                </ol>
                <div className="mt-10 grid sm:mt-16 items-center gap-10 lg:grid-cols-2">
                    <Reveal>
                        <div className="rounded-3xl border border-teal-600/25 bg-teal-50 p-8 lg:p-10">
                            <span className="grid h-11 w-11 sm:h-14 sm:w-14 place-items-center rounded-2xl bg-teal-700 text-white" aria-hidden="true">
                                <CalendarCheck className="h-7 w-7" />
                            </span>
                            <p className="mt-6 text-lg leading-relaxed text-ink" data-testid="steps-format-note">
                                Start with a one-hour introductory workshop, which includes no falling practice.
                                Then, if you&rsquo;d like, continue with the full course: eight sessions over four
                                weeks.
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <img
                            src="https://images.pexels.com/photos/11674390/pexels-photo-11674390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt="Adults in their 60s and 70s taking part in a group exercise class together"
                            className="aspect-[4/3] w-full rounded-[2rem] border border-clay object-cover"
                            loading="lazy"
                            data-testid="steps-image"
                        />
                    </Reveal>
                </div>
            </div>
        </section>
    );
}